import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock, Row, Col } from 'react-bootstrap'
import Select from "react-select";
import { SelectOptionsHelper } from '../../helpers/SelectOptionsHelper';
import { TableButton } from '../../TableButton';

export class POIActiveForm extends Component {
    onAddWorkingHours() {
        this.props.onChangeListValue("add", "workingHours", "");
    }

    onRemoveWorkingHours(workingHours) {
        this.props.onChangeListValue("delete", "workingHours", workingHours);
    }

    onAddContact() {
        this.props.onChangeListValue("add", "contacts", "");
    }

    onRemoveContact(contact) {
        this.props.onChangeListValue("delete", "contacts", contact);
    }

    // ----------------------

    renderWorkingHoursRemoveIcon(workingHours) {
        return (
            <TableButton icon="icon-error"
                title="Remover Horário"
                onClick={() => this.onRemoveWorkingHours(workingHours)} />
        );
    }

    renderContactRemoveIcon(contact) {
        return (
            <TableButton icon="icon-error"
                title="Remover Contacto"
                onClick={() => this.onRemoveContact(contact)} />
        );
    }

    renderWorkingHoursFormControl(workingHours, index) {
        return (
            <FormControl
                className="margin-top-5"
                type="text"
                value={workingHours}
                placeholder="Introduza o horário de funcionamento"
                onChange={(e) => this.props.onChangeListValue("update", "workingHours", e.target.value, index)}
            />
        );
    }

    renderWorkingHoursFormGroup() {
        const { form } = this.props;

        return (
            <FormGroup controlId="formWorkingHours" validationState={form.workingHoursInputError}>
                <ControlLabel>Horários de funcionamento</ControlLabel>
                <Button className="pull-right" onClick={() => this.onAddWorkingHours()}> + </Button>
                {
                    form.obj.workingHours.map((wh, idx) =>
                        <Row className={idx === 0 ? "margin-top-10" : ""} key={`wh-${idx}`}>
                            <Col xs={11}>
                                {this.renderWorkingHoursFormControl(wh, idx)}
                            </Col>
                            {this.renderWorkingHoursRemoveIcon(wh)}
                        </Row>
                    )
                }

                {form.workingHoursInputError !== null ?
                    <HelpBlock> Nenhum horário pode estar vazio. </HelpBlock> :
                    null
                }
            </FormGroup>
        );
    }

    renderContactsFormControl(contact, index) {
        return (
            <FormControl
                className="margin-top-5"
                type="text"
                value={contact}
                placeholder="Introduza o contacto"
                onChange={(e) => this.props.onChangeListValue("update", "contacts", e.target.value, index)}
            />
        );
    }

    renderContactsFormGroup() {
        const { form } = this.props;

        return (
            <FormGroup controlId="formContacts" validationState={form.contactsInputError}>
                <ControlLabel>Contactos</ControlLabel>
                <Button className="pull-right" onClick={() => this.onAddContact()}> + </Button>
                {
                    form.obj.contacts.map((ct, idx) =>
                        <Row className={idx === 0 ? "margin-top-10" : ""} key={`ct-${idx}`}>
                            <Col xs={11}>
                                {this.renderContactsFormControl(ct, idx)}
                            </Col>
                            {this.renderContactRemoveIcon(ct)}
                        </Row>
                    )
                }

                {form.contactsInputError !== null ?
                    <HelpBlock> Nenhum contacto pode estar vazio. </HelpBlock> :
                    null
                }
            </FormGroup>
        );
    }

    render() {
        const { form } = this.props;

        if (undefined === form) {
            return null;
        }

        const { show } = this.props;

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formDescription">
                            <ControlLabel>Descrição</ControlLabel>

                            <FormControl
                                type="text"
                                value={form.obj.description}
                                placeholder="Introduza a descrição"
                                onChange={(e) => this.props.onChangeValue(e, 'description')}
                            />
                        </FormGroup>

                        <FormGroup controlId="formType" validationState={form.typeInputError}>
                            <ControlLabel>Tipo</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Tipos de Ponto de Interesse"
                                noOptionsMessage={() => "Sem Tipos de Ponto de Interesse Configurados"}
                                onChange={(e) => this.props.onSelectValue(e, "type")}
                                options={SelectOptionsHelper.PointOfInterestTypes}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    if (null !== form.obj.type && undefined !== form.obj.type) {
                                        return form.obj.type === a.value;
                                    }
                                }}
                                getOptionValue={value => value.value}
                                getOptionLabel={label => label.label}
                                value={SelectOptionsHelper.PointOfInterestTypes.find(x => x.value === (0 <= form.obj.type && form.obj.type < 6 ? form.obj.type : 0))}
                            />
                            {form.typeInputError !== null ?
                                <HelpBlock> Tipo inválido </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formCoordX" validationState={form.coordXInputError}>
                            <ControlLabel>Latitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.coordX}
                                placeholder="Introduza a latitude"
                                onChange={(e) => this.props.onChangeValue(e, 'coordX')}
                            />
                            {form.coordXInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formCoordY" validationState={form.coordYInputError}>
                            <ControlLabel>Longitude</ControlLabel>
                            <FormControl
                                type="number"
                                value={form.obj.coordY}
                                placeholder="Introduza a longitude"
                                onChange={(e) => this.props.onChangeValue(e, 'coordY')}
                            />
                            {form.coordYInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        {this.renderWorkingHoursFormGroup()}
                        {this.renderContactsFormGroup()}
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pointsOfInterest/POIActiveForm.js